/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPaymentPersonalInformationFormOptions interface.
 */
export function instanceOfFxIdDomainSettingsPaymentPersonalInformationFormOptions(value) {
    return true;
}
export function FxIdDomainSettingsPaymentPersonalInformationFormOptionsFromJSON(json) {
    return FxIdDomainSettingsPaymentPersonalInformationFormOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPaymentPersonalInformationFormOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Compact': json['Compact'] == null ? undefined : json['Compact'],
        'DisplayTitle': json['DisplayTitle'] == null ? undefined : json['DisplayTitle'],
    };
}
export function FxIdDomainSettingsPaymentPersonalInformationFormOptionsToJSON(json) {
    return FxIdDomainSettingsPaymentPersonalInformationFormOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPaymentPersonalInformationFormOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Compact': value['Compact'],
        'DisplayTitle': value['DisplayTitle'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPaymentPersonalInformationFormOptions.js.map